// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c89a9d2e","667":"aca1177f","977":"03469c1c"}[chunkId] + ".chunk.js";
};